import React from 'react';

export default function CampInput({
  label,
  error,
  hint,
  className = '',
  id,
  ...props
}) {
  const inputId =
    id || `camp-input-${String(label || props.name || 'field').replace(/\s+/g, '-')}`;

  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={inputId}
          className="mb-1.5 block text-sm font-semibold text-camp-green-deep"
        >
          {label}
        </label>
      )}

      <input
        id={inputId}
        className={[
          'w-full rounded-camp border bg-white px-3.5 py-2.5',
          'text-camp-carbon placeholder:text-camp-gray',
          'outline-none transition',
          error
            ? 'border-camp-danger focus:ring-4 focus:ring-red-100'
            : 'border-camp-gray-light focus:border-camp-green focus:ring-4 focus:ring-camp-100',
          className,
        ].join(' ')}
        {...props}
      />

      {error ? (
        <p className="mt-1.5 text-sm text-camp-danger">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-sm text-camp-gray">{hint}</p>
      ) : null}
    </div>
  );
}
